import { render, staticRenderFns } from "./upd_complete.vue?vue&type=template&id=5840f612&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5840f612')) {
      api.createRecord('5840f612', component.options)
    } else {
      api.reload('5840f612', component.options)
    }
    module.hot.accept("./upd_complete.vue?vue&type=template&id=5840f612&lang=pug&", function () {
      api.rerender('5840f612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payment/upd_complete.vue"
export default component.exports